module.exports = __webpack_public_path__ + "static/headphones-products-by-category-sorting-tabs-section-dc800c6185ef0622477b3c41b5f0104a.png";